/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import clsx from 'clsx';

import { accessKeyForMessages } from '../../utils/constants';
import { submitContactForm } from '../../utils/api';
import { Spinner } from '../AnimatedImages/Spinner/Spinner';
import { Success } from '../AnimatedImages/Success/Success';
import { Error } from '../AnimatedImages/Success/Error';

import styles from './ContactForm.module.css';

export const ContactForm = () => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    control,
    formState: { errors, isSubmitSuccessful, isSubmitting },
  } = useForm({
    mode: 'onTouched',
  });
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [Message, setMessage] = React.useState('');

  const userName = useWatch({
    control,
    name: 'name',
    defaultValue: 'Someone',
  });

  useEffect(() => {
    setValue('subject', `${userName} ждет звонка с сайта WE MAKE KITCHEN`);
  }, [userName, setValue]);

  const onSubmit = async (data: any, e: any) => {
    await submitContactForm(data)
      .then(async (response) => {
        const json = await response.json();
        if (json.success) {
          setIsSuccess(true);
          setMessage('Мы свяжемся с вами в самое ближайшее время.');
          e.target.reset();
          reset();
        } else {
          setIsSuccess(false);
          setMessage('Свяжитесь с нами, любым другим доступным способом.');
          console.log(json.message);
        }
      })
      .catch((error) => {
        setIsSuccess(false);
        setMessage('Свяжитесь с нами, любым другим доступным способом.');
        console.log(error);
      });
  };

  return (
    <div className={styles.dialog}>
      <div className={styles.contentContact}>
        <div className="h-full flex-1">
          {!isSubmitSuccessful && (
            <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
              <div className={styles.textBox}>
                <h3 className={styles.title}>
                  Мы очень рады, что вы заинтересованы обсутройством своего
                  жилья вместе с нами!
                </h3>
                <div className={styles.subtitle}>
                  <p>
                    Оставьте свои контакты и мы свяжемся с Вами в ближайшее
                    время.
                  </p>
                  <p>Обычно это занимает не более 2-х часов.</p>
                </div>
              </div>
              <input
                type="hidden"
                value={accessKeyForMessages}
                {...register('access_key')}
              />
              <input type="hidden" {...register('subject')} />
              <input
                type="hidden"
                value="WMK: Заявка на обратную связь"
                {...register('from_name')}
              />
              <input
                type="checkbox"
                id=""
                className="hidden"
                style={{ display: 'none' }}
                {...register('botcheck')}
              />
              <div className={styles.inputsBox}>
                <div>
                  <label htmlFor="name" className="sr-only">
                    Name
                  </label>
                  <input
                    id="name"
                    type="text"
                    placeholder="Имя"
                    disabled={isSubmitting}
                    className={clsx(
                      styles.input,
                      errors.name ? styles.errorInput : 'border-dark',
                    )}
                    {...register('name', {
                      required: 'Пожалуйста, укажите Ваше имя',
                      maxLength: 80,
                    })}
                  />
                  {errors.name && (
                    <div className={styles.errorText}>
                      {/* @ts-ignore */}
                      <small>{errors.name.message}</small>
                    </div>
                  )}
                </div>

                <div>
                  <label htmlFor="contactNumber" className="sr-only">
                    Contact Number
                  </label>
                  <input
                    id="contactNumber"
                    type="tel"
                    placeholder="+7 (999) 999-99-99"
                    disabled={isSubmitting}
                    className={clsx(
                      styles.input,
                      errors.contactNumber ? styles.errorInput : 'border-dark',
                    )}
                    {...register('contactNumber', {
                      required: 'Пожалуйста, укажите ваш номер телефона',
                      pattern: {
                        value:
                          /^(\+7|7|8)(-| )?\(?\d{3}\)?(-| )?\d{3}(-| )?\d{2}(-| )?\d{2}$/,
                        message:
                          'Пожалуйста, введите корректный номер телефона',
                      },
                    })}
                  />
                  {errors.contactNumber && (
                    <div className={styles.errorText}>
                      {/* @ts-ignore */}
                      <small>{errors.contactNumber.message}</small>
                    </div>
                  )}
                </div>

                <button type="submit" className={styles.submitButton}>
                  {isSubmitting ? <Spinner /> : 'Свяжитесь со мной'}
                </button>
              </div>
              <div>
                <div className={styles.extraText}>
                  <p>
                    Нажимая на кнопку, вы даете согласие на обработку
                    персональных данных и соглашаетесь с
                  </p>
                  <p>политикой конфиденциальности </p>
                </div>
              </div>
            </form>
          )}
          {isSubmitSuccessful && isSuccess && (
            <>
              <div className={styles.infoBox}>
                <Success />
                <h3>Ваш запрос успешно отправлен!</h3>
                <p>{Message}</p>
              </div>
            </>
          )}

          {isSubmitSuccessful && !isSuccess && (
            <div className={styles.infoBox}>
              <Error />
              <h3>Упс, что-то пошло не так!</h3>
              <p>{Message}</p>
              <button onClick={() => reset()}>Попробовать снова</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
